<template>
	<div class="page" style="background-color: #f2f5fa;">
		<img :src="'./images/morehead.jpg'" style="width: 100%;">

		<div style="padding: 4%;">
			<div class="mitem" @click="goPage('/bkinfo')">
				<div class="mimg">
					<img :src="'./images/icon-baoming.png'" />
				</div>
				<div class="mtxt">
					报名信息
				</div>
			</div>
			<div class="mitem" @click="goPage(0)">
				<div class="mimg">
					<img :src="'./images/icon-zhuanye.png'" />
				</div>
				<div class="mtxt">
					专业考试
				</div>
			</div>
			<div class="mitem" @click="goPage(0)">
				<div class="mimg">
					<img :src="'./images/icon-wenhua.png'" />
				</div>
				<div class="mtxt">
					文化考试
				</div>
			</div>
			<div class="mitem" @click="goPage(0)">
				<div class="mimg">
					<img :src="'./images/icon-jiaofei.png'" />
				</div>
				<div class="mtxt">
					录取缴费情况
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {}
		},
		mounted() {

		},
		methods: {
			goPage(path) {
				if (path) {
					let url = path + "?pmid=" + this.$route.query.pmid + "&openid=" + this.$route.query.openid
					console.log(url)
					this.$router.push(url)
				}else{
					alert("敬请期待")
				}
			}
		}
	}
</script>

<style scoped="">
	.mitem {
		width: 48%;
		height: 45vw;
		display: inline-block;
		vertical-align: top;
		margin-right: 4%;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		background-color: #fff;
		margin-bottom: 14px;
	}

	.mitem:nth-child(2n) {
		margin-right: 0;
	}

	.mitem:active {
		box-shadow: 0 0 5px 1px rgba(18, 131, 255, 0.5);
	}

	.mtxt {
		text-align: center;
		padding-top: 10px;
		color: #666666;
	}

	.mimg {
		width: 40%;
		height: 40%;
		border-radius: 50%;
		margin: 0 auto;
		margin-top: 20%;
	}

	.mimg img {
		width: 100%;
		border-radius: 50%;
	}
</style>
